import { actionConst } from '../constants/service.constants';
import { requestListConstants } from '../containers/Requests/request-list.constants';
import moment from 'moment';
import { requestsConstants } from '../containers/Requests/requests.constants';
import { authHeader, authUploadHeader } from '../helpers/auth-header';
import { client } from './';
import { requestsActions } from '../containers/Requests/requests.actions';

const url = '/Request';

const actions = {
	openServiceModal,
	closeServiceModal,
	postService,
}

function postService(value) {

	let rurl = url + '/set_service/' + value.request;

	return (dispatch,getState) => {

		client.put(rurl, value.newServiceId, { headers: authHeader() })
			.then(response => {
				console.log(response)
				const rl = getState().requestsStore.requests.slice()
				const ri = rl.findIndex(el => ''+el.id === value.request)		
				rl[ri].service = value.newService
				rl[ri].serviceId = value.newServiceId
		
				dispatch({
					type: requestsConstants.SET_REQUEST_SERVICE,
					payload: new Promise(resolve=>{resolve({data: rl})}),
				})

			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function openServiceModal(r,ps,psid,sid,hsid) {

	let rurl = url + '/services?parentIds=' + psid + '&houseId=' + hsid;

	return dispatch => {

		client.get(rurl, { headers: authHeader() }).then(response=> {

		dispatch({
			type: actionConst.OPEN_SERVICE_MODAL,
			payload: {r, ps, psid, sid, services: response.data},
		})
	}).catch( error => {
			console.log(error);
	})
	}
}

function closeServiceModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_SERVICE_MODAL
		})
	}
}

export default actions;